// E-E-A-T: named human authors for blog articles.
// Founders of FOD by DMB Partners — alternated across articles.
export const AUTHORS = {
  edina: {
    name: "Edina BERISHA",
    url: "https://www.fodbydmb.com/a-propos",
    jobTitle: "Co-fondatrice, FOD by DMB Partners",
    displayName: "Edina Berisha",
    photo: "/team/edina-berisha.jpg",
  },
  hugo: {
    name: "Hugo DAUGERON-MIJOIN",
    url: "https://www.fodbydmb.com/a-propos",
    jobTitle: "Co-fondateur, FOD by DMB Partners",
    displayName: "Hugo Daugeron-Mijoin",
    photo: "/team/hugo-daugeron-mijoin.jpg",
  },
};

// Explicit mapping slug → author (alternated). Falls back to Edina.
export const AUTHOR_BY_SLUG = {
  "comparateur-frais-bancaires-pme-eti-2026-toutes-les-banques-sont-elles-competitives": AUTHORS.edina,
  "pourquoi-un-audit-des-frais-bancaires-est-devenu-indispensable-en-2026": AUTHORS.hugo,
  "frais-monetiques-des-pme-eti-ce-que-vous-payez-vraiment-et-ou-se-cachent-les-marges": AUTHORS.edina,
  "vous-avez-3-banques-ou-plus-on-passe-sur-ebics": AUTHORS.hugo,
  "10-minutes-pour-savoir-si-votre-entreprise-surpaye-sa-banque": AUTHORS.edina,
  "comparatif-frais-bancaires-entreprise-2025": AUTHORS.hugo,
};

// Admin-chosen author (post.author = "edina" | "hugo") wins; legacy slug mapping otherwise.
export function getAuthorKey(slug, author) {
  if (AUTHORS[author]) return author;
  return AUTHOR_BY_SLUG[slug] === AUTHORS.hugo ? "hugo" : "edina";
}

export function getArticleAuthor(slug, author) {
  return AUTHORS[getAuthorKey(slug, author)];
}
